import {
  EDUCATION_LEVEL_DISPLAY,
  KINSHIP_LEVEL_DISPLAY,
  REASON_CONTRACT_CANCELATION_DISPLAY,
} from "@utils/displays";
import {
  ACCOUNT_TYPE,
  CONTRACTS_REPORT_TYPE,
  EDUCATION_LEVEL,
  KINSHIP_LEVEL,
  REASON_CONTRACT_CANCELATION,
} from "@utils/enums";

export const LOCAL_STORAGE = {
  USER: "user",
  LAST_JOURNEY: "lastJourney",
  FORCED_RELOAD_STORAGE: "lastForcedReload",
};

export const BENEFIT_CARD_ACCOUNT_TYPE_LIST = [
  {
    value: ACCOUNT_TYPE.CONTA_CORRENTE_PESSOA_FISICA,
    label: "Conta Corrente Pessoa Física",
  },
  {
    value: ACCOUNT_TYPE.CONTA_POUPANCA_PESSOA_FISICA,
    label: "Conta Poupança Pessoa Física",
  },
  {
    value: ACCOUNT_TYPE.CONTA_PAGAMENTO_PESSOA_FISICA,
    label: "Conta Pagamento Pessoa Física",
  },
];

export const MARITAL_STATUS_TYPE_LIST = [
  {
    value: "Solteiro(a)",
    label: "Solteiro(a)",
  },
  {
    value: "Casado(a)",
    label: "Casado(a)",
  },
  {
    value: "Divorciado(a)",
    label: "Divorciado(a)",
  },
  {
    value: "Viúvo(a)",
    label: "Viúvo(a)",
  },
];

export const STATUS_LIST = [
  {
    value: 1,
    label: "Digitação",
  },
  {
    value: 2,
    label: "Aguardando Formalização",
  },
  {
    value: 3,
    label: "Formalizado",
  },
  {
    value: 4,
    label: "Mesa",
  },
  {
    value: 5,
    label: "Em averbação",
  },
  {
    value: 6,
    label: "Pago",
  },
  {
    value: 7,
    label: "Cancelado",
  },
];

export const CONTRACTS_REPORT_TYPE_LIST = [
  {
    value: CONTRACTS_REPORT_TYPE.GERAL,
    label: "Produto/Status",
  },
  {
    value: CONTRACTS_REPORT_TYPE.DIGITACAO,
    label: "Digitação",
  },
  {
    value: CONTRACTS_REPORT_TYPE.FINALIZACAO,
    label: "Finalização",
  },
];

export const EDUCATION_LEVEL_LIST = [
  {
    value: EDUCATION_LEVEL.FUNDAMENTAL,
    label: EDUCATION_LEVEL_DISPLAY[EDUCATION_LEVEL.FUNDAMENTAL],
  },
  {
    value: EDUCATION_LEVEL.MEDIO,
    label: EDUCATION_LEVEL_DISPLAY[EDUCATION_LEVEL.MEDIO],
  },
  {
    value: EDUCATION_LEVEL.SUPERIOR,
    label: EDUCATION_LEVEL_DISPLAY[EDUCATION_LEVEL.SUPERIOR],
  },
  {
    value: EDUCATION_LEVEL.POS_GRADUADO,
    label: EDUCATION_LEVEL_DISPLAY[EDUCATION_LEVEL.POS_GRADUADO],
  },
  {
    value: EDUCATION_LEVEL.ANALFABETO,
    label: EDUCATION_LEVEL_DISPLAY[EDUCATION_LEVEL.ANALFABETO],
  },
];

export const KINSHIP_LEVEL_LIST = [
  {
    value: KINSHIP_LEVEL.CONJUGE,
    label: KINSHIP_LEVEL_DISPLAY[KINSHIP_LEVEL.CONJUGE],
  },
  {
    value: KINSHIP_LEVEL.PAI,
    label: KINSHIP_LEVEL_DISPLAY[KINSHIP_LEVEL.PAI],
  },
  {
    value: KINSHIP_LEVEL.MAE,
    label: KINSHIP_LEVEL_DISPLAY[KINSHIP_LEVEL.MAE],
  },
  {
    value: KINSHIP_LEVEL.FILHO,
    label: KINSHIP_LEVEL_DISPLAY[KINSHIP_LEVEL.FILHO],
  },
  {
    value: KINSHIP_LEVEL.IRMAO,
    label: KINSHIP_LEVEL_DISPLAY[KINSHIP_LEVEL.IRMAO],
  },
];

export const BOOLEAN_CHOICES = [
  {
    value: 1,
    label: "Sim",
  },
  {
    value: 0,
    label: "Não",
  },
];

export const REASON_CONTRACT_CANCELATION_LIST = [
  {
    value: REASON_CONTRACT_CANCELATION.DESISTENCIA_CLIENTE,
    label:
      REASON_CONTRACT_CANCELATION_DISPLAY[
        REASON_CONTRACT_CANCELATION.DESISTENCIA_CLIENTE
      ],
  },
  {
    value: REASON_CONTRACT_CANCELATION.FORMALIZACAO_EXPIRADA,
    label:
      REASON_CONTRACT_CANCELATION_DISPLAY[
        REASON_CONTRACT_CANCELATION.FORMALIZACAO_EXPIRADA
      ],
  },
];
